<template>
    <EditingDialog 
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="License"
                        :items="licenseItems" 
                        :label="$t('lang_CONTRACTS_LABEL_CAPTION_LICENSE_BASE')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa +'-dropdown-license'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="SalesType"
                        :items="salesTypeItems" 
                        :label="$t('lang_LABEL_SALES_DATA_CAPTION_SALES_TYPE')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa +'-dropdown-sales-type'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="SalesUnit"
                        :items="salesUnitItems" 
                        :label="$t('lang_LABEL_SALES_DATA_CAPTION_SALES_UNIT')"
                        :selection="true"
                        :withMargin="false"
                        :alvqa="alvqa +'-dropdown-sales-unit'"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Base"
                        :label="$t('lang_CONTRACTS_LABEL_EDIT_SPLITS_PANEL_CAPTION_BASE')"
                        :withMargin="false"
                        rules="percentDecimal|required"
                        :alvqa="alvqa +'-textfield-base'"
                        suffix="%"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Shares"
                        :label="$t('lang_GENERAL_CAPTION_SPLIT')"
                        :withMargin="false"
                        rules="percentDecimal|required"
                        :alvqa="alvqa +'-textfield-split'"
                        suffix="%"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Category"
                        :items="categoryItems" 
                        :label="$t('lang_LABEL_SALES_DATA_CAPTION_CATEGORY')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa +'-dropdown-category'"
                    />
                </v-col>
            </v-row>
            <!-- rules="required" -->
            <BaseRegions 
                :context="context + 'EditingDialog'"
                includeLabel="lang_PUBLISHING_WORKS_EXPORT_INCLUDE_TERRITORY"
                excludeLabel="lang_PUBLISHING_WORKS_EXPORT_EXCLUDE_TERRITORY"
                :includeItems="includeItems"
                :excludeItems="excludeItems"
                includeCols="5"
                excludeCols="5"
                :clearable="false"
                
                :alvqa="alvqa"
            />
        </template>
    </EditingDialog>
</template>

<script>
import 
    { 
        DropdownContractsLabelPriceCategories, 
        DropdownContractsLabelSalesType,
        DropdownContractsLabelLicense,
        DropdownContractsLabelSalesUnits
    } 
from '@/assets/dropdowns/alvDropdowns.js'

import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseRegions from '@/components/_base/BaseRegions'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "LabelContractsSplitsEditPanelDialog",
    components: {
        EditingDialog,
        BaseRegions,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: "LabelContractsSplits",
            alvqa: "contracts-label-edit-form-splits-panel-editing-dialog"
        }
    },
    computed: {
        licenseItems() { return DropdownContractsLabelLicense },
        salesTypeItems() { return DropdownContractsLabelSalesType },
        salesUnitItems() { return DropdownContractsLabelSalesUnits },
        categoryItems() { return DropdownContractsLabelPriceCategories },
        includeItems() { 
            let storeIncludes = this.$alvPlugin.getListOfTranslatedCountries()
            storeIncludes.unshift({text: this.$t('lang_CAPTION_REGION_WORLD'), value: 'WORLD'})
            return storeIncludes
        },
        excludeItems() { return this.$alvPlugin.getListOfTranslatedCountries() },
    },
    created() {
        this.$store.commit('setCountries')
    },
}
</script>